import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var DevRoleSwitcherAuthService = /** @class */ (function () {
    function DevRoleSwitcherAuthService() {
        this.AUTH_STORAGE_KEY = 'dev_role_switcher_authenticated';
        this.authSubject = new BehaviorSubject(false);
        this.auth$ = this.authSubject.asObservable();
        // Load initial state from sessionStorage
        this.checkAuthState();
    }
    /**
     * Check authentication state from sessionStorage
     */
    DevRoleSwitcherAuthService.prototype.checkAuthState = function () {
        try {
            var authState = sessionStorage.getItem(this.AUTH_STORAGE_KEY);
            var isAuthenticated = authState === 'true';
            this.authSubject.next(isAuthenticated);
            return isAuthenticated;
        }
        catch (e) {
            this.authSubject.next(false);
            return false;
        }
    };
    /**
     * Set authentication state
     */
    DevRoleSwitcherAuthService.prototype.setAuthenticated = function (authenticated) {
        try {
            if (authenticated) {
                sessionStorage.setItem(this.AUTH_STORAGE_KEY, 'true');
            }
            else {
                sessionStorage.removeItem(this.AUTH_STORAGE_KEY);
            }
            this.authSubject.next(authenticated);
        }
        catch (e) {
            // Silently fail - sessionStorage may not be available
        }
    };
    /**
     * Get current authentication state
     */
    DevRoleSwitcherAuthService.prototype.isAuthenticated = function () {
        return this.authSubject.value;
    };
    DevRoleSwitcherAuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DevRoleSwitcherAuthService_Factory() { return new DevRoleSwitcherAuthService(); }, token: DevRoleSwitcherAuthService, providedIn: "root" });
    return DevRoleSwitcherAuthService;
}());
export { DevRoleSwitcherAuthService };
